import React, { useEffect, useState, useContext } from 'react'
import { Button, Col, Divider, Drawer, Input, message, Radio, Row, Select, Typography, Spin } from 'antd'
import debounce from 'lodash/debounce'
import Utils from '../../../../utils/Utils'
import DiscountList from './DiscountList'
import { Context } from '../../../../context'

const { Title } = Typography
const { Option } = Select

function PresentationDrawer(props) {
  const [{ auth }] = useContext(Context)
  const [description, setDescription] = useState('')
  const [productId, setProductId] = useState(null)
  const [productDescription, setProductDescription] = useState(null)
  const [minimalGroup, setMinimalGroup] = useState(false)
  const [numberOfUnits, setNumberOfUnits] = useState('')
  const [price, setPrice] = useState('')
  const [products, setProducts] = useState([])
  const [fetching, setFetching] = useState(false)
  const [dataDiscounts, setDataDiscounts] = useState([])
  const initDataSource = JSON.stringify([{ id: 1, discount_level: '', discount_percentage: '', discount_amount: '' }])
  const [dataSource, setDataSource] = useState(JSON.parse(initDataSource))

  useEffect(() => {
    setDescription(props.edit ? props.editData.description : '')
    setProductId(props.edit ? props.editData.product_id : null)
    setProductDescription(props.edit ? props.editData.product_name : null)
    setMinimalGroup(props.edit ? props.editData.is_grouping === 1 : false)
    setNumberOfUnits(props.edit ? props.editData.units : '')
    setPrice(props.edit ? props.editData.price : '')
    setProducts([])
    onSearchProducts('')
    if (props.visible) {
      onSearchProducts(props.edit ? props.editData.product_name : '')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible])

  useEffect(() => {
    if (props.edit) {
      onSearchProducts('')
      setProducts([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible])

  useEffect(() => {
    if (props.visible) {
      let discountLevelList = []
      setDataSource(
        props.edit && props?.editData && props.editData?.discount_presentation.length > 0
          ? props.editData.discount_presentation.map(value => {
            let _dataSource = {
              discount_level: value.discount_level,
              discount_percentage: value.pivot.discount_percentage,
              discount_amount: value.pivot.discount_amount,
              company_id: value.company_id,
              id: value.id
            }
            discountLevelList.push(value.discount_level)
            return _dataSource
          })
          : []
      )

      let noIncludeDiscount = []
      props.dataDiscounts.forEach(d => {
        const datax = discountLevelList.find(s => {
          return d.discount_level === s;
        });
        if (!datax) {
          noIncludeDiscount.push(d)
        }
      });

      setDataDiscounts(noIncludeDiscount)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible])

  const onSearchProducts = val => {
    setFetching(true)
    const excludeChars = Utils.excludedCharsContent(val)
    Utils.getProductsOption(val, excludeChars, 'desc')
      .then(response => {        
        if (response?.data?.data) {        
          setProducts(response.data.data)
          setFetching(false)
        }
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la información de fabricantes')
      })
  }

  const onSave = () => {
    let _presentation = {
      product_id: productId,
      description: description,
      price: price,
      is_grouping: minimalGroup ? 1 : 0,
      units: minimalGroup ? numberOfUnits : 1
    }

    let msn = Utils.isEmpty(_presentation)
    if (msn) {
      return message.error(`Todos los campos son Obligatorios`)
    } else if (minimalGroup && numberOfUnits <= 1) {
      return message.error(`El número de unidades debe ser mayor a 1`)
    }

    let discounts = dataSource.map((item) => {
      if (item.discount_level !== '' && item.discount_percentage !== '' && item.discount_amount !== '') {
        item.discount_amount = Number(item.discount_amount)
        return item
      } else {
        return message.error(`Todos los campos son Obligatorios`)
      }
    });

    let flag = true
    discounts.forEach(item => {
      if (!item) {
        flag = false
      }
    })

    if (flag) {
      if (!discounts[0]) discounts = []
      _presentation.discounts = discounts

      props.saveButton(props.edit, _presentation, props.edit ? props.editData.id : null)

      setDataSource(JSON.parse(initDataSource))
    }
  }

  const onClose = () => {
    props.closable()
    setProducts([])
    setDataSource(JSON.parse(initDataSource))
  }

  return (
    <>
      <Drawer placement="right" closable={false} onClose={onClose} visible={props.visible} width={800}>
        <div className={'products-container-tabs'} style={{ height: '100%' }}>
          <Title> {props.edit ? 'Editar presentación' : 'Nueva presentación'} </Title>
          <Divider className={'divider-custom-margins-users'} />

          <Row gutter={16} className={'section-space-field'}>
            <Col xs={12} sm={12} md={12} lg={12}>
              <div className={'title-space-field'}>Descripción</div>
              <Input
                value={description}
                onChange={value => setDescription(value.target.value)}
                placeholder={'Descripción del nuevo producto'}
                size={'large'}
              />
            </Col>
            <Col xs={12} sm={12} md={12} lg={12}>
              <div className={'title-space-field'}>Producto al que pertenece*</div>
              <Select
                defaultValue={productDescription}
                showSearch
                optionFilterProp="children"
                className={'single-select'}
                placeholder={'Seleccionar producto al que pertenece'}
                size={'large'}
                style={{ width: '100%' }}
                value={productId}
                onChange={value => setProductId(value)}
                onSearch={debounce(onSearchProducts, 800)}
                notFoundContent={fetching ? <Spin size="small" /> : null}
                getPopupContainer={trigger => trigger.parentNode}
              >
                {products &&
                  products.map(data => {
                    return (
                      <Option key={data.id} value={data.id}>
                        {data.description}
                      </Option>
                    )
                  })}
              </Select>
            </Col>
          </Row>

          {/*End Fields section*/}
          {/*Radio button section*/}
          <Row gutter={16} className={'section-space-list section-space-list-bottom'}>
            <Col xs={12} sm={12} md={12} lg={12}>
              <span className={'label-bold-500 presentation-ratio-button-labels'}>¿Es agrupación de la expresión mínima del producto?</span>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Radio.Group
                className={'radio-group'}
                optionType="button"
                buttonStyle="solid"
                size={'large'}
                value={minimalGroup}
                onChange={value => setMinimalGroup(value.target.value)}
              >
                <Radio.Button value={false}>No</Radio.Button>
                <Radio.Button value={true}>Sí</Radio.Button>
              </Radio.Group>
            </Col>
          </Row>
          {/*End Radio button section*/}
          {/*Fields section*/}
          <Row gutter={16} className={'section-space-field'}>
            <Col xs={16} sm={16} md={16} lg={16}>
              <div className={'title-space-field'}>Número de unidades de la expresión mínima del producto</div>
              <Input
                disabled={!minimalGroup}
                value={minimalGroup ? numberOfUnits : 1}
                onChange={value => setNumberOfUnits(value.target.value)}
                placeholder={'Escribir número de unidades de la expresión minima del producto'}
                size={'large'}
                type={'number'}
              />
            </Col>
            <Col xs={8} sm={8} md={8} lg={8}>
              <div className={'title-space-field'}>Precio sugerido</div>
              <Input
                value={price}
                onChange={value => setPrice(value.target.value)}
                placeholder={'Escribe un precio'}
                size={'large'}
                type={'number'}
              />
            </Col>
          </Row>

          {auth?.company?.allow_discount_levels === 1 && (
            <>
              <Divider className={'divider-custom-margins-users'} />
              <Row gutter={16} className={'section-space-field'}>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <div className={'title-space-field'} style={{ textAlign: 'center', fontSize: 'x-large' }}>Niveles de descuento</div>
                </Col>
              </Row>

              <Row gutter={16} className={'section-space-list'}>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <DiscountList currency={props.editData?.currency} price={price} setDataDiscounts={setDataDiscounts} propsDataDiscounts={props.dataDiscounts} edit={props.edit} initDataSource={initDataSource} dataDiscounts={dataDiscounts} visible={props.visible} dataSource={dataSource} setDataSource={setDataSource} />
                </Col>
              </Row>
            </>
          )}


        </div>
        <div>
          {/*Footer buttons section*/}
          <Row gutter={16}>
            <Col xs={24} sm={24} md={24} lg={24}>
              <div className="text-right">
                <div>
                  <Button
                    type={'link'}
                    className="cancel-button"
                    onClick={() => {
                      setProducts([])
                      setDataSource(JSON.parse(initDataSource))
                      props.cancelButton()
                    }}
                  >
                    Cancelar
                  </Button>
                  <Button htmlType="submit" className="title-tendero new-button" onClick={() => onSave()}>
                    Guardar
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        {/*End Footer buttons section*/}
      </Drawer>
    </>
  )
}

export default PresentationDrawer
